import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appInfo: {
      version: 19.2
    },
    company: {
      backendId: '',
      info: {},
      images: {},
      theme: {},
      settings: {}
    },
    userLoaded: false,
    user: {
      loggedIn: false,
      isAdmin: false
    },
    urlpath: `/${process.env.VUE_APP_SERVER_BASE}`
  },
  mutations: {
    setUserLoaded: (state, payload) => {
      state.userLoaded = payload
    },
    setUser: (state, payload) => {
      state.user = payload
    },
    setBackendId: (state, payload) => {
      state.company.backendId = payload
    },
    setInfo: (state, payload) => {
      state.company.info = payload
    },
    setTheme: (state, payload) => {
      state.company.theme = payload
    },
    setImages: (state, payload) => {
      state.company.images = payload
    },
    setSettings: (state, payload) => {
      state.company.settings = payload
    }
  },
  actions: {
    setUser: ({ commit }, payload) => {
      commit('setUser', {
        loggedIn: payload.loggedIn,
        isAdmin: payload.isAdmin,
        backendId: payload.backendId,
        username: payload.username,
        email: payload.email
      })
      commit('setBackendId', payload.backendId)
    },
    setBackendId: ({ commit, state }, payload) => {
      commit('setBackendId', payload)
      return axios.get(state.urlpath + 'services/getBackendIdData.php?id=' + payload, {
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
        .then((response) => {
          commit('setInfo', {
            'name': response.data.name,
            'address1': response.data.address1,
            'address2': response.data.address2,
            'email': response.data.email,
            'vat': response.data.vat
          })
          commit('setTheme', response.data.theme)
          commit('setImages', response.data.images)
          commit('setSettings', response.data.settings)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
    },
    setTheme: ({ commit }, payload) => {
      commit('setTheme', payload)
    },
    loadUser: ({ commit, state }) => {
      return axios.get(state.urlpath + 'services/getUser.php')
        .then(function (response) {
          commit('setUser', response.data)
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
        .then(() => {
          // always executed
          commit('setUserLoaded', true)
        })
    },
    logout: ({ commit, state }) => {
      commit('setUser', {
        loggedIn: false,
        isAdmin: false
      })
      axios.post(state.urlpath + 'services/logout.php')
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
    }
  },
  getters: {
    getAppInfo: state => {
      return state.appInfo
    },
    urlPath: state => {
      return state.urlpath
    },
    isLoggedIn: state => {
      return state.user.loggedIn
    },
    isAdmin: state => {
      return state.user.isAdmin
    },
    getUserLoaded: state => {
      return state.userLoaded
    },
    getUser: state => {
      return state.user
    },
    getBackendId: state => {
      return state.company.backendId
    },
    getInfo: state => {
      return state.company.info
    },
    getImages: state => {
      return state.company.images
    },
    getTheme: state => {
      return state.company.theme
    },
    getSettings: state => {
      return state.company.settings
    }
  }
})
